<template>
  <div>
    <h2 class="text-center">{{ $route.meta.title }}</h2>
    <el-container>
      <el-header height="auto" class="header-container">
        <el-row>
          <el-col :span="12">
            <span class="input-label">姓名</span>
            <el-input
              placeholder="輸入姓名"
              @input="searchUsers()"
              v-model="keyword"
            ></el-input>
            <el-button type="primary" @click="searchUsers()">搜尋</el-button>

            <router-link
              :to="{ name: 'newLongTermUser' }"
              style="margin-left: 50px"
            >
              <el-button type="success">+ 新增長照用戶</el-button>
            </router-link>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-row>
          <el-col :md="24" :lg="24">
            <el-select
              size="small"
              v-model="paging.perPage"
              @change="searchUsers()"
              placeholder="選擇"
              style="margin-bottom: 20px"
            >
              <el-option
                v-for="item in defaultOption.perPageOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-table :data="queryResult" header-row-class-name="table-header">
              <div slot="empty" class="el-table__empty-text">暫無資料</div>

              <el-table-column prop="id" label="編號"></el-table-column>
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="areaType" label="區域類型">
                <template slot-scope="scope">
                  <span>
                    {{ defaultOption.areaTypeLookup[scope.row.areaType] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="payForOwnselfProportion" label="自費比例">
                <template slot-scope="scope">
                  <span>{{ scope.row.payForOwnselfProportion }}%</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="telephoneNumber"
                label="住家電話"
              ></el-table-column>
              <el-table-column
                prop="firstMobilePhoneNumber"
                label="手機"
              ></el-table-column>
              <el-table-column
                prop="subsidyMaximumAmount"
                label="上限金額"
              ></el-table-column>
              <el-table-column
                prop="subsidyLastAmount"
                label="本月剩餘金"
              ></el-table-column>
              <el-table-column label="動作" width="100px">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      name: 'longTermUserDetail',
                      params: { id: scope.row.id },
                    }"
                  >
                    <el-button
                      size="primary"
                      round
                      plain
                      style="padding-top: 1px; padding-bottom: 1px"
                    >
                      檢視
                    </el-button>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-main>
      <el-footer>
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="paging.totalPages"
          :page-size="paging.perPage"
          :current-page.sync="paging.currentPage"
          :total="paging.totalEntries"
          @current-change="searchUsers"
          @size-change="searchUsers"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
const log = console.log
import { defaultOption } from './defaultOption'
import longTermCareService from '@/API/longTermCareService'
export default {
  methods: {
    searchUsers() {
      /** FIXME: [backend] 欄位不一致 */
      const {
        keyword,
        paging: { perPage: per_page = 25, currentPage: current_page = 1 },
      } = this

      this.$router.replace({
        name: 'longTermUserList',
        query: { per_page, current_page },
      })

      return longTermCareService
        .queryUsers({ keyword, current_page, per_page })
        .then((data) => {
          log('query result', data)
          return data.result
        })
        .then(({ data, paging }) => {
          this.queryResult = data || []
          this.paging = paging || {}
        })
    },
  },
  created() {
    this.searchUsers()
  },
  data() {
    const parseQuery = (query) => {
      const { per_page, current_page, keyword } = query

      return {
        paging: {
          perPage: per_page && Number(per_page),
          currentPage: current_page && Number(current_page),
        },
        keyword,
      }
    }

    const initial = parseQuery(this.$route.query)
    return {
      defaultOption,
      keyword: initial.keyword || null,
      queryResult: [],
      paging: { ...initial.paging },
    }
  },
}
</script>

<style scoped>
.el-input {
  width: auto;
}

.header-container {
  padding: 20px;
  background: #ecf0f5;
}

.table-header > th,
.table-header > tr {
  font-weight: 400;
  background: #eee !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/UserList.vue